import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private apiLoaded = false;
  private loadPromise?: Promise<void>;

  load(): Promise<void> {
    if (this.apiLoaded || (globalThis as any).google) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.google.mapKey}&libraries=places,marker`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.apiLoaded = true;
        resolve();
      };

      script.onerror = () => {
        reject(new Error('Não foi possível carregar o Google Maps.'));
      };

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
